export const RaceOptions = [
  { label: '', value: '' },
  { label: 'Chinese', value: 'chinese' },
  { label: 'Malay', value: 'malay' },
  { label: 'Indian', value: 'indian' },
  { label: 'Others', value: 'others' }
]
